export default __webpack_public_path__ + "media/user-o.7cc98901.svg";